import Route from '@ember/routing/route';
import { service } from '@ember/service';
import type RouterService from '@ember/routing/router-service';
import type FeaturesService from 'tio-common/services/features';
import { SLR_LOAN_VERIFICATION_FLAG } from 'tio-employee/utils/slr/loan-verification';

/** Decides only the rollout gate: the page component loads the question itself, so the transition never waits. */
export default class AuthenticatedSlrLoanVerificationRoute extends Route {
  @service declare features: FeaturesService;
  @service declare router: RouterService;

  /** Sends a flag-off visitor to the SLR dashboard; otherwise falls through to the page. */
  beforeModel() {
    if (!this.features.isEnabled(SLR_LOAN_VERIFICATION_FLAG)) {
      this.router.replaceWith('authenticated.slr.dashboard');
    }
  }

  /** @returns the question's id; the page fetches it, so the route never waits */
  model(params: { resolution_id: string }) {
    return { resolutionId: params.resolution_id };
  }
}

export type AuthenticatedSlrLoanVerificationModel = ReturnType<
  AuthenticatedSlrLoanVerificationRoute['model']
>;
